import get from 'lodash/get';
import { toKeysMap } from 'utils/array';
import { getDefaultReportingWindow } from 'utils/channels';

const rows = [
  { label: 'Channel Default', reportingWindow: 'default' },
  { label: 'Premiere', reportingWindow: 'premiere' },
  { label: 'Live 7', reportingWindow: 'live7' },
  { label: 'Live 30', reportingWindow: 'live30' },
  { label: 'All Time', reportingWindow: 'allTime' },
];

const getImpressionsByWindow = (
  rollupMetricSummary,
  defaultReportingWindow,
) => {
  const globalImpressions = (rollupMetricSummary || []).filter(
    ({ country, metricType }) =>
      country === 'global' && metricType === 'impressions',
  );
  const impressions = toKeysMap(globalImpressions, 'reportingWindow');
  impressions.defaultReportingWindow = impressions[defaultReportingWindow];
  return impressions;
};

export function getMetricsTable(
  rollupMetricSummary,
  youtubeData,
  defaultReportingWindow,
) {
  if (youtubeData) {
    return {
      columns: [
        { id: 'views', label: 'Views' },
        { id: 'likes', label: 'Likes' },
      ],
      metrics: Object.keys(youtubeData.demographics).reduce(
        (acc, reportingWindow) => ({
          ...acc,
          [reportingWindow]: youtubeData.demographics[reportingWindow].metrics,
        }),
        {},
      ),
      rows: rows.filter((row) => row.reportingWindow !== 'premiere'),
    };
  }

  const impressions = getImpressionsByWindow(
    rollupMetricSummary,
    defaultReportingWindow,
  );

  return {
    columns: [{ id: 'impressions', label: 'Impressions' }],
    metrics: Object.keys(impressions).reduce(
      (acc, key) => ({
        ...acc,
        [key]: { impressions: impressions[key].value },
      }),
      {},
    ),
    rows,
  };
}

export const getReportingWindow = (filters, channel, integration) => {
  const deliverableReportingWindow = get(
    integration,
    'deliverable.reportingWindow',
  );
  const filterMetricWindow = get(filters, 'f.metric.window');

  if (filterMetricWindow) {
    return filterMetricWindow;
  }

  if (get(filters, 'f.campaignId') && deliverableReportingWindow) {
    return deliverableReportingWindow;
  }

  return getDefaultReportingWindow(channel?.name);
};

export const mergeRollupMetricSummaries = (
  placementRollupMetricSummary,
  sourceRollupMetricSummary,
) => {
  const result = {};

  (placementRollupMetricSummary || []).forEach((metric) => {
    const value = get(result, `${metric.reportingWindow}.value`) || 0;
    result[metric.reportingWindow] = {
      ...metric,
      value: value + metric.value,
    };
  });

  (sourceRollupMetricSummary || []).forEach((metric) => {
    const value = get(result, `${metric.reportingWindow}.value`) || 0;
    result[metric.reportingWindow] = {
      ...metric,
      value: value + metric.value,
    };
  });

  return Object.values(result);
};

export const getCpm = (live7impressions, mediaValues) =>
  live7impressions && mediaValues
    ? (mediaValues.live7 / live7impressions.value) * 1000
    : 0;
